import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/AddToCompare.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/client/link.js");
